"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const WidgetExtensionPlugin_1 = require("./WidgetExtensionPlugin");
const Mixin_1 = require("../../Util/Mixin");
const IContainerInjection_1 = require("../../Container/IContainerInjection");
const WidgetExtensionPluginDefinition_1 = require("./WidgetExtensionPluginDefinition");
const WidgetEvents_1 = require("../../Widget/EventDefinition/WidgetEvents");
/**
 * Widget extensions that scrolls the viewport in view when steps change.
 */
class ScrollInViewExtension extends WidgetExtensionPlugin_1.default {
    constructor(definition, scrollInViewService) {
        super(definition);
        /**
         * Whether the widget is first rendering.
         */
        this.isFirstRender = true;
        this.scrollInViewService = scrollInViewService;
    }
    /**
     * @inheritDoc
     */
    static create(definition, container) {
        return new this(definition, container.get("scroll_in_view"));
    }
    /**
     * @inheritDoc
     */
    initialize(widget) {
        return Promise.resolve().then(() => {
            if (!widget.getConfig().isAutoScrollInViewEnabled()) {
                return;
            }
            widget.getEventContainer().on(WidgetEvents_1.WidgetEvents.STEP_RENDERED, () => {
                if (!widget.getConfig().shouldAutoScrollOnFirstRender() && this.isFirstRender) {
                    this.isFirstRender = false;
                    return;
                }
                this.containerElement = widget.getContainer();
                // Prevent breaking the widget with auto-scroll since it's not a necessary
                // functionality, but still warn about issue.
                try {
                    if (!this.scrollInViewService.isInView(this.containerElement)) {
                        this.scrollInViewService.scrollInView(this.containerElement);
                    }
                }
                catch (e) {
                    console.warn(`WF (${widget.getConfig().getContainerId()}): Malfunctioning auto in-view scroll.`);
                    console.warn(e);
                }
            });
        });
    }
}
exports.default = ScrollInViewExtension;
Mixin_1.default(ScrollInViewExtension, IContainerInjection_1.default);
exports.ScrollInViewExtensionDefinition = new WidgetExtensionPluginDefinition_1.default({
    class: ScrollInViewExtension,
    id: "auto_scroll_in_view"
});
